import * as tslib_1 from "tslib";
/* I91 in DS */
// from GDrive
import React from 'react';
import IconWrap from '../IconWrap';
var Download = function (props) {
    return (React.createElement(IconWrap, tslib_1.__assign({}, props),
        React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" },
            React.createElement("g", null,
                React.createElement("path", { d: "M21.98 23H2.02v-4h1.96v2h16.04v-2h1.96z" }),
                React.createElement("path", { d: "M14 4v7h2.58l.5.54-5.05 5.4-5.14-5.44.47-.5H10V4h4zm2-2H8v7H6.49l-2.36 2.51 8 8.35 7.78-8.33L17.48 9H16V2z" })))));
};
Download.displayName = 'Download';
export default Download;
//# sourceMappingURL=Download.js.map